import React from "react";
import { formatDateTime } from "../../../utils/dateTime";
import { formatMinutes } from "./overtimeFormat";

const EMPTY = [];

/**
 * "Level 2 of 3" for a multi-level request still pending. Overtime, leave and
 * corrections are one step now (any one approver decides), so `oneStep`
 * (the default) shows nothing.
 */
export const LevelBadge = ({ levels, status, oneStep = true }) =>
  oneStep || !levels || !(levels.total > 1) ? null : (
    <span className="chip chip--sm chip--alt" title="Approval level">
      {status === "PENDING"
        ? `Level ${levels.current} of ${levels.total}`
        : `${levels.total} levels`}
    </span>
  );

/**
 * Who acted at each level so far:
 * approvals = [{ level, action APPROVE|REJECT, name, asHr, at, remarks, approvedMinutes? }].
 */
const ApprovalTrail = ({ approvals = EMPTY, levels }) =>
  approvals.length === 0 ? (
    levels?.total > 1 ? (
      <p className="fs-075 text-slate-500 mb-0">No level approved yet.</p>
    ) : null
  ) : (
    <ol className="approval-trail">
      {approvals.map((a, i) => (
        <li
          key={`${a.level}-${i}`}
          className={a.action === "REJECT" ? "is-reject" : "is-approve"}
        >
          <i
            className={`bi ${a.action === "REJECT" ? "bi-x-circle-fill" : "bi-check-circle-fill"}`}
            aria-hidden="true"
          ></i>
          <div>
            <div className="fs-080">
              <strong>Level {a.level}</strong> ·{" "}
              {a.action === "REJECT" ? "Rejected" : "Approved"} by {a.name}
              {a.asHr && <span className="chip chip--sm ms-1">as HR</span>}
              {a.approvedMinutes !== undefined &&
                a.approvedMinutes !== null && (
                  <span className="text-slate-500">
                    {" "}
                    · {formatMinutes(a.approvedMinutes)}
                  </span>
                )}
            </div>
            <div className="fs-070 text-slate-500">{formatDateTime(a.at)}</div>
            {a.remarks && (
              <div className="fs-075 text-slate-600 fst-italic">
                “{a.remarks}”
              </div>
            )}
          </div>
        </li>
      ))}
    </ol>
  );

export default ApprovalTrail;
